export const TIMEZONE = {
  KST: "Asia/Seoul",
  UTC: "UTC"
} as const
